"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScriptTypes = void 0;
const list_source_hook_1 = require("../../utils/list-source-hook");
function useScriptTypes() {
    return list_source_hook_1.useStaticListSource([
        { id: 'GROOVY', name: 'Groovy' },
        { id: 'JAVASCRIPT', name: 'Javascript' },
    ]);
}
exports.useScriptTypes = useScriptTypes;
//# sourceMappingURL=actions-api.js.map